import { MeasureNurseryDomainService } from './domain';
import { MeasureFactory } from './entity/measureFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { MeasureJson } from '@/types/domain/measure/entities/measureEntity';

/**
 * 測定アプリケーションサービス(施設)
 */
export class MeasureNurseryApplicationService {
  private service!: MeasureNurseryDomainService;

  private measureFactory = new MeasureFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new MeasureNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurseryMeasure
   * @param input input
   */
  async sendNurseryMeasure(
    input: MeasureJson,
  ) {
    const entity = this.measureFactory.createFromJson(input);
    await this.service.sendNurseryMeasure(entity);
  }

  /**
   * removeNurseryMeasure
   * @param input input
   */
  async removeNurseryMeasure(
    input: MeasureJson,
  ) {
    const entity = this.measureFactory.createFromJson(input);
    await this.service.removeNurseryMeasure(entity);
  }
}
